export default __webpack_public_path__ + "static/instagram-e5d33894db79dd729be96c402b478d81.png";